module.exports = __webpack_public_path__ + "img/icn_selected.709ee8b6.svg";